
        
        <!-- <div class="row"> -->
            <!-- <div class="col-4 shadow-sm" style="height: 80vh;"> -->
                <div class="row  shadow-sm" style="height: 60px; ">
                    <div class="col-md-12 " style="background-color:#E7E7E7"  >
                        <input type="text" class="search-box shadow-sm m-3" placeholder="Search/ Filter Your Contact " [(ngModel)]='filterText'>
                    </div>
                </div>
                <div *ngFor="let i= index; let chat of contact| chatFilter:filterText" >

                    <div class="mt-3"  (click)="messageReciever(i)">
                            <img [src]="chat.picture" style="height: 40px; width: 40px; border-radius: 100%;"/>
                            {{chat.Name }} 
                    </div>
                    <hr style="color:white">
                </div>
                <button class="btn btn" (click)="logOut()" style="margin-top:20em; background-color: #585FA5">Logout</button>
            <!-- </div> -->
        <!-- </div> -->
        
    